import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { formatCustomDateTime } from 'common/helpers/date.helper';
import WorkSansRegular from '../../../../assets/fonts/WorkSans-Regular.ttf';
import WorkSansBold from '../../../../assets/fonts/WorkSans-Bold.ttf';
import WorkSansMedium from '../../../../assets/fonts/WorkSans-Medium.ttf';
import { IPrintDailyActivityReportsProps } from './print-daily-activity-reports.types';

const PrintDailyActivityReports = (data: IPrintDailyActivityReportsProps, ref: any) => {
  Font.registerHyphenationCallback((w) => [w]);
  Font.register({
    family: 'Work Sans',
    fonts: [
      { src: WorkSansRegular, fontWeight: 400 },
      { src: WorkSansBold, fontWeight: 600 },
      { src: WorkSansMedium, fontWeight: 500 },
    ],
  });

  const Header = () => {
    return (
      <View fixed style={styles.header}>
        <Image src={data.logoIconBase64} style={styles.logo} />
        <View>
          <Text style={[styles.dataValue, styles.text]}>{`${formatCustomDateTime(data.dateFrom / 1000, true)} - ${formatCustomDateTime(
            data.dateTo / 1000,
            true,
          )}`}</Text>
        </View>
      </View>
    );
  };

  const Footer = () => {
    return (
      <View fixed style={styles.footer}>
        <Image src={data.reportIconBase64} style={styles.logo} />
      </View>
    );
  };

  return (
    <Document>
      <Page size={'A4'} style={styles.page}>
        <Header />
        <View style={styles.row} wrap={false}>
          <View style={{ width: 120 }}>
            <Text style={[styles.dataTitle, styles.text]}>Dispatcher</Text>
          </View>
          <View style={{ width: 260 }}>
            <Text style={[styles.dataTitle, styles.text]}>Entry Details</Text>
          </View>
          <View style={{ width: 180 }}>
            <Text style={[styles.dataTitle, styles.text]}>Date & Time</Text>
          </View>
        </View>
        <View style={styles.delimiter}></View>
        {data.data.map((item, index) => {
          return (
            <View key={`daily-activity-report-item-${index}`}>
              <View style={styles.row} wrap={false} key={`report-${index}`}>
                <View style={{ width: 120 }}>
                  <Text style={[styles.dataValue, styles.text]}>{`${item.dispatcher}`}</Text>
                </View>
                <View style={{ width: 260 }}>
                  <Text style={[styles.dataValue, styles.text]}>{`${item.entryDetails}`}</Text>
                </View>
                <View style={{ width: 180 }}>
                  <Text style={[styles.dataValue, styles.text]}>{`${formatCustomDateTime(item.timestamp / 1000, true)}`}</Text>
                </View>
              </View>
              <View style={styles.delimiter}></View>
            </View>
          );
        })}
        <Footer />
      </Page>
    </Document>
  );
};

export default PrintDailyActivityReports;

const styles = StyleSheet.create({
  footer: { display: 'flex', alignItems: 'flex-end', position: 'absolute', bottom: 10, left: 20, right: 20, height: 40 },
  row: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: 10 },
  text: { color: '#292B2E' },
  dataTitle: { fontSize: 12, fontWeight: 500, marginBottom: 5 },
  dataValue: { fontSize: 14, fontWeight: 400 },
  delimiter: { borderBottom: '1pt solid #E3E5E8', marginTop: 5, marginBottom: 5 },
  page: {
    paddingTop: 15,
    paddingHorizontal: 20,
    paddingBottom: 60,
    fontFamily: 'Work Sans',
    color: '#292B2E',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    marginBottom: 30,
  },
  logo: {
    width: 100,
  },
});
